import { TypeAutresInfosATTR } from './TypeAutresInfosATTR';
import { AvisInitialType } from './AvisInitialType';
import { DescriptionReduite } from './DescriptionReduite';
import { Attribution } from './Attribution';
import { TypeCrJugement } from './TypeCrJugement';

export class TypeAnn_DIVER_G2 {

  public autresInformations: TypeAutresInfosATTR;

  public avisInitial: AvisInitialType;

  public descriptionReduite: DescriptionReduite;

  public attribution: Attribution;

  public criteresAttribution: TypeCrJugement;

  public pasAvisInitial: string;

  public procedure: string;

  public resultatAttribution: string;

  constructor() {
    this.autresInformations = new TypeAutresInfosATTR();
    this.avisInitial = new AvisInitialType();
    this.descriptionReduite = new DescriptionReduite();
    this.attribution = new Attribution();
    this.criteresAttribution = new TypeCrJugement();
    this.pasAvisInitial = '';
    this.procedure = '';
    this.resultatAttribution = '';
  }
}
